"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnNzAud = exports.EnNzUsd = exports.EnNzNzd = void 0;
class EnNzNzd {
    constructor() {
        this.locale = "en-nz";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM, yyyy",
            long: "dddd, dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "NZD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnNzNzd = EnNzNzd;
class EnNzUsd {
    constructor() {
        this.locale = "en-nz";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM, yyyy",
            long: "dddd, dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "US$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnNzUsd = EnNzUsd;
class EnNzAud {
    constructor() {
        this.locale = "en-nz";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM, yyyy",
            long: "dddd, dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "AUD",
            symbol: "AU$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnNzAud = EnNzAud;
